module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Horário de funcionamento da loja","description":"(Informe pelos um horário de atendimento)"},"en-US":{"title":"Store opening hours","description":"(Provide open hours)"}}')
  delete Component.options._Ctor
}
